import React from "react";
import styled from "styled-components";

// components
import { TabItem } from "./BottomNavbarComponents";

// assets
import LightHome from "assets/icons/light/menu_home.svg";
import LightSchedule from "assets/icons/light/menu_schedule.svg";
import LightSales from "assets/icons/light/menu_sales.svg";
import LightStore from "assets/icons/light/menu_store.svg";
import LightAll from "assets/icons/light/menu_report.svg";

import LightHomeFocus from "assets/icons/light/menu_home_focus.svg";
import LightScheduleFocus from "assets/icons/light/menu_schedule_focus.svg";
import LightSalesFocus from "assets/icons/light/menu_sales_focus.svg";
import LightStoreFocus from "assets/icons/light/menu_store_focus.svg";
import LightAllFocus from "assets/icons/light/menu_report_focus.svg";

// note : ugly..

const BottomNavbar = () => {
  const bottomNavbarList = [
    {
      href: "/home",
      icons: {
        default: LightHome,
        active: LightHomeFocus,
      },
      label: "홈",
    },
    {
      href: "/schedule",
      icons: {
        default: LightSchedule,
        active: LightScheduleFocus,
      },
      label: "스케줄",
    },
    {
      href: "/sales",
      icons: {
        default: LightSales,
        active: LightSalesFocus,
      },
      label: "매출",
    },
    {
      href: "/report",
      icons: {
        default: LightAll,
        active: LightAllFocus,
      },
      label: "리포트",
    },
  ];

  return (
    <Wrapper>
      {bottomNavbarList.map((item, index) => {
        return (
          <TabItem
            key={index}
            href={item?.href}
            icons={item?.icons}
            label={item?.label}
          />
        );
      })}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  flex-direction: row;
  align-items: center;
`;

export default BottomNavbar;
